import { useState, type ComponentType } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import './SwitchNavigation.css';
import { Croatian } from '../../model/Croatian';
import { English } from '../../model/English';
import type { Language } from '../../model/Language';
import { Russian } from '../../model/Russian';
import { Serbian } from '../../model/Serbian';

const languages = [new English(), new Russian(), new Serbian(), new Croatian()];

function SwitchNavigation() {
  const { i18n } = useTranslation();
  const [selectedLanguage, selectLanguage] = useState<string>(i18n.language);

  const handleClick = async (lang: Language) => {
    await i18n.changeLanguage(lang.toIETF());
    selectLanguage(lang.toIETF());
  };

  return (
    <ul className="switch-navigation_ul">
      {languages.map(lang => (
        <li>
          <button
            aria-label={'switch-button_' + lang.toIETF()}
            className={`${lang.isSelectedLanguage(selectedLanguage) ? 'switch-button_bold' : ''}`}
            onClick={() => handleClick(lang)}
          >
            {lang.toButtonText()}
          </button>
        </li>
      ))}
    </ul>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, react-refresh/only-export-components
export const SwitchNavigationWithTranslation: ComponentType<any> =
  withTranslation()(SwitchNavigation);

export default SwitchNavigationWithTranslation;
